'use strict';

(function () {
    'use strict';

    angular.module('zp').directive('searchDatepicker', searchDatepicker);

    /** @ngInject */
    function searchDatepicker(DatepickerModel, moment) {
        return {
            restrict: 'E',
            link: link,
            transclude: true,
            replace: true,
            scope: {
                dateChange: '=',
                dateModel: '=',
                searchModel: '=',
                hideIcon: '&?',
                datePlaceholder: '=?',
                dateName: '=?',
                dateFormat: '=',
                readOnly: '&?'
            },
            templateUrl: 'app/results/filters/search.datepicker.html'
        };

        function link(scope, element, attributes) {

            scope.toggleDatepicker = toggleDatepicker;
            scope.dateChanged = dateChanged;
            scope.dateModel = scope.dateModel ? scope.dateModel : new DatepickerModel();
            scope.hideIcon = scope.hideIcon ? scope.hideIcon : false;
            scope.dateReadonly = scope.dateReadonly ? scope.dateReadonly : false;
            scope.datePlaceholder = scope.datePlaceholder ? scope.datePlaceholder : '';
            scope.dateName = scope.dateName ? scope.dateName : 'datepicker';
            scope.readOnly = !!scope.readOnly;
            if (!!scope.dateFormat) {
                scope.dateModel.dateFormat = scope.dateFormat;
            }
            //////////////////////////////////////////////////////

            function toggleDatepicker() {
                scope.dateModel.show = !scope.dateModel.show;
            }

            function dateChanged() {
                if (!scope.dateModel || !scope.dateModel.display) {
                    return false;
                }

                var d = new Date(scope.dateModel.display);

                if (!!scope.searchModel.initialized && !scope.searchModel.initialized) {
                    var timeZone = moment.tz.guess();
                    var timeDiff = moment(d).tz(timeZone).format('Z');
                    var zone = parseInt(timeDiff);
                    d.setHours(d.getHours() + zone);
                }

                if (!!scope.searchModel) {
                    scope.searchModel[scope.dateName] = moment(d);
                }

                if (!!scope.dateChange) {
                    scope.dateChange(scope.dateName, d);
                }
            }
        }
    }
})();